import * as Actions from '../../actions/superuser';

const initialState={
    data: {},
    isLoading: false,
    isUpdated: false,
    error: false
};

const superuser=function(state=initialState,action) {
    switch(action.type) {
        case Actions.GET_SUPERUSER: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.GET_SUPERUSER_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                error: false
            }
        }
        case Actions.GET_SUPERUSER_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }


        case Actions.UPDATE_SUPERUSER: {
            return {
                ...state,
                isLoading: true,
                isUpdated: false,
                error: false
            };
        }
        case Actions.UPDATE_SUPERUSER_SUCCESS: {

            return {
                ...state,
                data: {...state.data,...action.payload},
                isLoading: false,
                isUpdated: true,
                error: false
            };
        }
        case Actions.UPDATE_SUPERUSER_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                isUpdated: false,
                error: action.error
            };
        }

        default: {
            return state;
        }
    }
};

export default superuser;